/**
 * Change styles to owl difference comments.
 */
 function owl_difference_comments(){
    const elements = document.querySelectorAll(".owl-difference-comments-container");  
    if (elements.length) {
        elements.forEach(function (element) { 
            $(element).owlCarousel({
                stageOuterClass: 'owl-wrapper-outer',
                stageClass: 'owl-wrapper',
                rewind: true,
                autoplay: true,
                autoplaySpeed: 500,
                autoplayTimeout: 5000,
                autoplayHoverPause: true,
                responsiveClass: true,
                responsive: {
                    0: {
                        items: 1
                    },
                    767: {
                        items: 2
                    },
                    1025: {
                        items: 3
                    }
                }
            });
        });
    }
}

owl_difference_comments();

export default owl_difference_comments;